import { DevelopusTreeTableBodyType } from '../DevelopusTreeTableBody'
import DevelopusTreeTableRowUIModel from './DevelopusTreeTableRowUIModel'

class DevelopusTreeTableBodyUIModel {
  constructor(rows: DevelopusTreeTableRowUIModel[]) {
    this.rows = rows
  }

  private readonly rows: DevelopusTreeTableRowUIModel[]

  toUI(): DevelopusTreeTableBodyType {
    return {
      items: this.rows.map((row) => row.toUI()),
    }
  }
}

export default DevelopusTreeTableBodyUIModel
